module.exports = __webpack_public_path__ + "img/auweblogo-en.04429a51.svg";